import { getHopSkipConfig } from 'lib/auth/auth.config'
import ReactGA from 'react-ga4'
import generateClientIdGa from './generateClientIdGa'

const getGoogleAnalyticsKey = () => {
	const config = getHopSkipConfig()
	return config.googleAnalytics.key
}

const ga = {
	initGoogleAnalytics() {
		const trackingId = getGoogleAnalyticsKey()
		if (!trackingId)
			console.warn('No tracking id is found for Google Analytics')

		ReactGA.initialize([
			{
				trackingId,
				gaOptions: {
					anonymizeIp: true,
					clientId: generateClientIdGa()
				}
			}
		])
	}
}

export default ga
